<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Lista de Carritos</h1>
		<div class="results" v-if="carts">
			<div class="results__element" v-for="(cart, index) in carts" :key="index">
				<div class="results__info">
					<h2 class="results__title">Id de Usuario: {{ cart.user_id }}</h2>
					<p class="results__text" v-if="cart.date_updated">Actualizado: {{ cart.date_updated | longDate('es-MX') }}</p>
					<p class="results__text">Tipo de usuario: {{ cart.guest_user == 1 ? 'Usuario no registrado' : 'Cliente registrado' }}</p>
				</div>
				<div class="results__actions">
					<button @click.prevent="$parent.$emit('view', cart.user_id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">
						Ver Carrito
					</button>
					<!-- TODO: BORRAR ITEMS Y DEVOLVER INVENTARIO ANTES DE BORRAR -->
					<button @click.prevent="deleteCart(cart.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">
						Borrar Carrito
					</button>
				</div>
			</div>
		</div>
		<div class="information" v-else>
			<p class="information__text">No se encontraron resultados</p>
		</div>
		<confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
	</div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
	props: {
		filters: {
			type: String,
			required: false,
			default: function() {
				return ''
			}
		}
	},
	mixins: [httpService],
	components: { confirmation },
	data: function() {
		return {
			cartId: null,
			carts: null,
			confirm: false
		}
	},
	created: function() {
		this.getCarts()
	},
	mounted: function() {
		this.$on('continue', () => {
			this.confirm = false
			this.proccedToDelete()
		})
	},
	watch: {
		filters: function() {
			this.getCarts()
		},
		'$store.state.elementChanged': {
			handler: function() {
				this.getCarts()
			},
			deep: true
		}
	},
	methods: {
		getCarts: function() {
			let httpRequest = {
				params: '?' + this.filters,
				module: 'shopping_carts'
			}
			this.get(httpRequest)
				.then(carts => {
					this.carts = carts.data
				})
				.catch(() => {
					this.carts = null
				})
		},
		deleteCart: function(id) {
			this.confirm = true
			this.cartId = id
		},
		proccedToDelete: function() {
			let httpRequest = {
				params: '',
				module: 'shopping_carts'
			}
			this.delete(this.cartId, httpRequest)
				.then(response => {
					this.getCarts()
					this.$store.commit('notificate', {
						title: 'CARRITO BORRADO',
						text: 'El carrito ha sido borrado correctamente',
						type: 'success'
					})
				})
				.catch(error => {
					this.$store.commit('notificate', {
						title: 'CARRITO NO BORRADO',
						text: 'No se pudo borrar el carrito seleccionado, por favor intente más tarde',
						type: 'warn'
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/shopping_carts/list.vue